import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    return {
        addBtn: {
            position: 'fixed',
            right: '20px',
            bottom: '20px',
            zIndex: '1',
        },
        airport: {
            fontSize: 18,
            fontWeight: 'bold',
            textAlign: 'center',
            backgroundColor: '#c8cacf',
        },
        filterContent: {
            display: 'flex',
            flexDirection: 'column',
        },
        filterIconActive: {
            color: theme.palette.primary.main,
        },
        page: {
            display: 'block',
            width: '100%',
            margin: '0 auto',
        },
        selectField: {
            width: 'auto',
            paddingLeft: '0',
            flex: '1 0 40%',
        },
        ul: {
            padding: 0,
        },
        wrapper: {
            paddingTop: 5,
        },
    };
});
